import React, { useRef } from "react";
import "./Contact.scss";
import emailjs from "@emailjs/browser";
import { motion } from "framer-motion";
import toast, { Toaster } from "react-hot-toast";
const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_wos5s5q", "template_akupgaf", form.current, {
        publicKey: "YzpEMEipHrGhk_I1g",
      })
      .then(
        () => {
          toast.success("Message send successfully!");
          console.log("SUCCESS!");
        },
        (error) => {
          console.log("FAILED...", error.text);
        }
      );
    e.target.reset();
  };
  return (
    <div className="container" id="contact">
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ y: [-50, 0], opacity: 1 }}
        className="title"
      >
        <span>get in touch</span>
        <h1>Contact Me</h1>
      </motion.div>
      <div className="contact_form">
        <motion.div
          initial={{ x: 0, opacity: 0 }}
          whileInView={{ x: [150, 0], opacity: 1 }}
          transition={{ duration: 1 }}
          className="contact_right"
        >
          <h3>Get In Touch</h3>
          <form ref={form} onSubmit={sendEmail}>
            <div className="row">
              <input
                type="text"
                name="from_name"
                placeholder="Full Name"
                required
              />
            </div>
            <div className="row">
              <input
                type="email"
                name="user_email"
                placeholder="Email"
                required
              />
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                required
              />
            </div>
            <div className="row">
              <textarea
                placeholder="Message"
                name="message"
                required
              ></textarea>
            </div>
            <motion.button className="btn" type="submit">
              Send Message
            </motion.button>
          </form>
        </motion.div>
        <Toaster />
      </div>
    </div>
  );
};

export default Contact;
